import * as React from "react";
import { Divider } from "@blueprintjs/core";

export const MultipleValues = ({ values }: { values: string[] | null | undefined }) => {
  if (!values || values.length === 0) {
    return null;
  }

  const result: React.ReactNode[] = [];
  for (let i = 0; i < values.length; ++i) {
    const val = values[i];
    if (i !== 0) {
      result.push(<Divider key={`divider-${i}`} />);
    }
    result.push(<React.Fragment key={`value-${val}-${i}`}>{val}</React.Fragment>);
  }
  return <div className="multiple-values">{result}</div>;
};
